import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			refresh: '.js-refresh',
			classes: {
				refresh: 'round-button_refresh'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$refresh = $(this.options.refresh);

		return this;
	}

	onClick = () => {
		this.$refresh.addClass(this.options.classes.refresh);
		setTimeout(() => {
			this.$refresh.removeClass(this.options.classes.refresh);
		}, 5000);
	}

	init() {
		this.$refresh.on('click', this.onClick);
	}

	render() {
		if (this.$refresh.length) {
			this.init();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/change/change.js